<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import FormInput from 'dashboard/components-next/input/Input.vue';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import { isWhatsappBrowserEnabledForAccount } from 'dashboard/composables/useWhatsappBrowserChannel';

export default {
  components: {
    PageHeader,
    NextButton,
    FormInput,
    SettingsFieldSection,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
  },
  mounted() {
    const accountId = Number(this.$route.params.accountId);
    const account = this.$store.getters['accounts/getAccount'](accountId);

    if (!isWhatsappBrowserEnabledForAccount(account)) {
      router.replace({
        name: 'settings_inbox_new',
        params: { accountId },
      });
    }
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const apiChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName?.trim(),
          channel: {
            type: 'waha_whatsapp',
          },
        });

        router.replace({
          name: 'settings_inbox_finish',
          params: {
            accountId: this.$route.params.accountId,
            inbox_id: apiChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP.BROWSER.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.BROWSER.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.BROWSER.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <SettingsFieldSection
        stacked
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL')"
      >
        <FormInput
          v-model="channelName"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          :message="
            v$.channelName.$error
              ? $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR')
              : ''
          "
          :message-type="v$.channelName.$error ? 'error' : 'info'"
          @blur="v$.channelName.$touch"
        />
      </SettingsFieldSection>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP.BROWSER.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
